import React from "react";
import { type BookkeepingCurrency } from "./hooks";
import LabelledRow from "components/labelledrow";
import ExchangeRatePicker from "./ExchangeRatePicker";

interface Props {
  bookkeepingCurrency: BookkeepingCurrency
  rowRef?: React.RefObject<HTMLTableRowElement>;
  validatorKey: string;
  error?: boolean
}

const ExchangeRatePickerTableRow = (props: Props) => {
  if (!props.bookkeepingCurrency.isExchangeRateVisible) return null;

  return <LabelledRow rowRef={props.rowRef} label={RESX.Financial.ExchangeRate}>
    <ExchangeRatePicker
      bookkeepingCurrency={props.bookkeepingCurrency}
      validatorKey={props.validatorKey}
      error={props.error}
    />
  </LabelledRow>;
};

export default ExchangeRatePickerTableRow;